import { Tooltip } from "antd";
import React, { useRef, useLayoutEffect, useState } from "react";

const TooltipText = ({ title, maxWidth = 120 }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [title, maxWidth]);

  return (
    <Tooltip title={isTruncated ? title : null} placement="topLeft">
      <span
        ref={textRef}
        style={{
          display: "inline-block",
          maxWidth,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "bottom",
          cursor: isTruncated ? "pointer" : "default",
        }}
      >
        {title}
      </span>
    </Tooltip>
  );
};

export default TooltipText;
